/**
 * Barre d'achat persistante sur mobile (page produit).
 *
 * Aucun formulaire supplémentaire : le bouton de la barre relaie le clic
 * vers le bouton « Ajouter au panier » de la page, donc la variante
 * choisie, la quantité et le panier tiroir de Dawn continuent de
 * fonctionner sans duplication de logique.
 */
(() => {
  const bar = document.getElementById('TsStickyAtc');
  if (!bar) return;

  const barButton = document.getElementById('TsStickyAtcButton');
  const barPrice = document.getElementById('TsStickyAtcPrice');

  // Le bouton d'achat principal est re-rendu par Dawn à chaque changement
  // de variante : on le relit à chaque fois plutôt que de le mémoriser.
  const mainButton = () =>
    document.querySelector('product-form .product-form__submit, form[action*="/cart/add"] .product-form__submit');

  // Dawn garde le prix barré dans le DOM et le masque en CSS : on lit donc
  // le montant qui est réellement affiché, sans les libellés d'accessibilité.
  const mainPrice = () => {
    const root = document.querySelector('.product__info-container .price, .product__info-wrapper .price');
    if (!root) return null;
    return root.classList.contains('price--on-sale')
      ? root.querySelector('.price-item--sale')
      : root.querySelector('.price-item--regular');
  };

  const anchor = mainButton();
  if (!anchor) return;

  bar.hidden = false;

  const setVisible = (visible) => {
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('ts-has-sticky-atc', visible);
  };

  // La barre ne sert à rien tant que le vrai bouton est à l'écran.
  const observer = new IntersectionObserver(
    ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0),
    { rootMargin: '0px 0px -20% 0px' }
  );
  observer.observe(anchor);

  barButton?.addEventListener('click', () => {
    const target = mainButton();
    if (!target || target.hasAttribute('disabled')) return;
    target.click();
  });

  // Refléter le prix et la disponibilité après un changement de variante.
  const sync = () => {
    const priceNode = mainPrice();
    const price = priceNode?.textContent.trim();
    if (price && barPrice) barPrice.textContent = price;

    const target = mainButton();
    if (target && barButton) {
      barButton.toggleAttribute('disabled', target.hasAttribute('disabled'));
      const label = target.querySelector('span')?.textContent.trim();
      if (label) barButton.textContent = label;
    }
  };

  const container = document.querySelector('.product__info-container, .product__info-wrapper');
  if (container) {
    new MutationObserver(sync).observe(container, { childList: true, subtree: true });
  }
  sync();
})();